let initialized = false;

export default function initHeader() {
    if (initialized) return;
    initialized = true;

    const header = document.querySelector('.site-header');
    const toggle = document.querySelector('.site-header__toggle');
    const nav = document.querySelector('.site-header__nav');

    if (!header) return;

    const close = () => {
        nav?.classList.remove('is-open');
        toggle?.setAttribute('aria-expanded', 'false');
    };

    const open = () => {
        nav?.classList.add('is-open');
        toggle?.setAttribute('aria-expanded', 'true');
    };

    toggle?.addEventListener('click', () => {
        const isOpen = nav?.classList.contains('is-open');
        if (isOpen) close(); else open();
    });

    // Sluit nav bij klik op een link (mobile): event-delegation zodat het ook
    // blijft werken nadat Barba de DOM heeft vervangen.
    nav?.addEventListener('click', (e) => {
        if (e.target.closest('a')) close();
    });

    // Sluit op Escape.
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && nav?.classList.contains('is-open')) {
            close();
            toggle?.focus();
        }
    });

    // Sluit bij klik buiten de nav (op mobiel).
    document.addEventListener('click', (e) => {
        if (!nav?.classList.contains('is-open')) return;
        if (header.contains(e.target)) return;
        close();
    });
}
